import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["secondary", "thesidebar"]

  toggleClass(event) {
    event?.preventDefault()
    const sidebar = this.thesidebarTarget
    const opening = sidebar.classList.contains("hidden")

    if (opening) {
      sidebar.classList.remove("hidden", "bg-opacity-10")
      sidebar.classList.add("fixed", "inset-0", "w-full", "h-full", "bg-ssbeige")
    } else {
      sidebar.classList.add("hidden", "bg-opacity-10")
      sidebar.classList.remove("fixed", "inset-0", "w-full", "h-full", "bg-ssbeige")
    }

    this.secondaryTargets.forEach((el) => el.classList.toggle("hidden"))
  }

  mouseOver() {}
  mouseOut() {}
}
